import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { Box, Grid, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ConnectionDetailPanel } from './ConnectionDetailPanel';
import { ConnectionsEmptyState } from './ConnectionsEmptyState';
import { ConnectionsListPanel } from './ConnectionsListPanel';
import { connectionsManageMessages as messages } from './connections-manage-messages';
import { ConnectionSuccessAlert } from './platforms/ConnectionSuccessAlert';
import { useConnectionsManageSelection } from './useConnectionsManageSelection';

type Props = {
  platform: SocialPlatform;
  connections: SocialExportGetConnectionStateDto[];
};

/**
 * Inner content that owns selection state once connections have loaded.
 */
export function ConnectionsManageContent({ platform, connections }: Props) {
  const { selectedConnectionId, selectedConnection, selectConnection } =
    useConnectionsManageSelection(connections);

  if (connections.length === 0) {
    return (
      <Box>
        <ConnectionsEmptyState platform={platform} />
      </Box>
    );
  }

  return (
    <Box maxWidth="lg">
      <ConnectionSuccessAlert platform={platform} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <ConnectionsListPanel
            platform={platform}
            connections={connections}
            selectedConnectionId={selectedConnectionId}
            onSelect={selectConnection}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          {selectedConnection ? (
            <ConnectionDetailPanel platform={platform} connection={selectedConnection} />
          ) : (
            <Box
              sx={{
                p: 2,
                borderRadius: 1,
                border: 1,
                borderColor: 'divider',
                bgcolor: 'background.paper',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 280,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage {...messages.selectConnection} />
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
